import { addToast } from 'core/notifications';
import axios from 'axios';
import i18n from 'i18next';
import truncate from 'lodash/truncate';

export default async ({ currentTreeContent, destination, item, organizationId, params }) => {
  const destinationId = destination.id === 0 ? null : destination.id;

  const data = {
    parent_list_item_id: destinationId,
    target_organization_id: organizationId,
  };

  await axios.put(`/api/admin/videos/${item.id}/move`, { data });

  await currentTreeContent.refetch();

  const currentTopicId = params.id;

  const shouldShowUserToast = item.id !== Number(currentTopicId);

  if (!shouldShowUserToast) return;

  const topicsPath = `/videos/organizations/${organizationId}/${params.type}/topics`;

  addToast(
    {
      button: {
        text: i18n.t('go-to-folder'),
        to: destinationId ? `${topicsPath}/${destinationId}` : topicsPath,
      },
      title: i18n.t('item-moved-to-destination', {
        destination: truncate(destination.data.name, { length: 50 }),
        item: truncate(item.data.name, { length: 50 }),
      }),
    },
    'success',
  );
};
